import './ViewAccountDetailsComponent.scss';
import ProfileFoundCardComponent from "../../../../shared/components/profile-found-card/ProfileFoundCardComponent";
import {Field, FieldProps, Form, Formik} from "formik";
import React, {useEffect} from "react";
import FormDebuggerComponent from "../../../../shared/components/form-debugger/FormDebuggerComponent";
import FormikSelectDropdownComponent
    from "../../../../shared/components/form-controls/formik-select-dropdown/FormikSelectDropdownComponent";
import AccordionComponent from "../../../../shared/components/accordion/accordionComponent";
import FormikRadioButtonComponent
    from "../../../../shared/components/form-controls/formik-radio-button/formikRadioButtonComponent";
import {CommonService} from "../../../../shared/services";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import * as Yup from "yup";
import moment from "moment";

interface ViewAccountDetailsComponentProps {
    profileFound: any;
    selectedProfile: any;
    setViewDetailsStep: any;
    viewDetailsStep: any;
    editProfileLink: any;
    no_mutual_access_object: any;
    mutual_access_object: any;
    accountDetailFormInitialValues: any;
    unLinkProfile: any;
}

const accountDetailFormValidationSchema = Yup.object().shape({
    permission_type: Yup.mixed().required('Permission type is required'),
});

const ViewAccountDetailsComponent = (props: ViewAccountDetailsComponentProps) => {
    const {
        profileFound,
        selectedProfile,
        accountDetailFormInitialValues,
        no_mutual_access_object,
        mutual_access_object,
        setViewDetailsStep,
        viewDetailsStep,
        editProfileLink,
        unLinkProfile
    } = props;
    const {relationshipList} = useSelector((state: IRootReducerState) => state.staticData);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    return (
        <div className="view-account-details-component">
            {
                viewDetailsStep === 'view' && <>
                    <div className={'wrapper'}>
                        <div className={"view-account-details-wrapper"}>
                            <div className="profile-card-wrapper">
                                <ProfileFoundCardComponent profileDetails={profileFound}/>
                            </div>

                            <div className={'permissions-content'}>
                                {selectedProfile?.requested_by === currentUser?.current_user_id &&
                                    <div className={'permissions-content-wrapper'}>
                                        <div className={'relationship--permission-heading'}>Relationship:</div>
                                        <div className={'relationship--permission-content'}>
                                            {selectedProfile?.relationship}
                                        </div>
                                    </div>}
                                <div className={'permissions-content-wrapper'}>
                                    <div className={'relationship--permission-heading'}>Permissions:</div>
                                    <div className={'relationship--permission-content'}>
                                        {selectedProfile?.permission_type === 'non_mutual' ? 'One-Way Access' : 'Mutual Access'}
                                        {selectedProfile?.permission_type === 'non_mutual' &&
                                            <ul className={'mrg-top-5 mrg-left-20'}>
                                                <li className={'mrg-bottom-10'}><b>You</b> have access to the other
                                                    person's account to book
                                                    appointments
                                                    and manage their account.
                                                </li>
                                                <li className={'mrg-bottom-10'}>The <b> other</b> person does not have
                                                    permission to access your
                                                    account.
                                                </li>
                                                <li>This access can be changed at any time.</li>
                                            </ul>}
                                        {
                                            selectedProfile?.permission_type === 'mutual' &&
                                            <ul className={'mrg-top-5 mrg-left-20'}>
                                                <li className={'mrg-bottom-10'}>
                                                    Gives the <b>other person</b> access to your account to book
                                                    appointments and manage your account on your behalf.
                                                </li>
                                                <li className={'mrg-bottom-10'}>
                                                    Gives <b>you</b> access to their account to book appointments and
                                                    manage their account.
                                                </li>
                                                <li>This access can be changed at any time.</li>
                                            </ul>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <div className="view-header">
                {(viewDetailsStep === 'view') &&
                    <div className={'button-actions'}>
                        <ButtonComponent color={'accent'} className={'mrg-right-15'} variant={'outlined'}
                                         onClick={() => unLinkProfile()}>Unlink
                            Profile</ButtonComponent>
                        <ButtonComponent color={'accent'} onClick={() => setViewDetailsStep('select')}>Update
                            Permissions</ButtonComponent>
                    </div>}
            </div>

            {viewDetailsStep === 'select' && <>
                <div className={"view-account-details-wrapper"}>
                    <div className="profile-card-wrapper">
                        <ProfileFoundCardComponent profileDetails={profileFound}/>
                    </div>
                    <div className={'permissions-content'}>
                        <div className={'permissions-content-wrapper'}>
                            <div className={'relationship--permission-heading'}>Date of Birth:</div>
                            <div className={'relationship--permission-content'}>
                                {moment(selectedProfile?.client_details?.dob).format('DD-MMM-YYYY') || 'N/A'}
                            </div>
                        </div>
                        {selectedProfile?.requested_by === currentUser?.current_user_id  &&
                            <div className={'permissions-content-wrapper'}>
                                <div className={'relationship--permission-heading'}>Relationship:</div>
                                <div className={'relationship--permission-content'}>
                                    {selectedProfile?.relationship}
                                </div>
                            </div>}
                        <div className={'permissions-content-wrapper'}>
                            <div className={'relationship--permission-heading'}>Permission:</div>
                            <div className={'relationship--permission-content'}>
                                {selectedProfile?.permission_type === 'non_mutual' ? 'One-Way Access' : 'Mutual Access'}

                            </div>
                        </div>
                    </div>

                </div>

                <Formik
                    validationSchema={accountDetailFormValidationSchema}
                    initialValues={accountDetailFormInitialValues}
                    validateOnChange={false}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}
                    onSubmit={editProfileLink}
                >
                    {({values, validateForm, isValid, isSubmitting, dirty}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                        }, [validateForm, values, dirty]);
                        return (
                            <Form className="t-form" noValidate={true}>
                                <FormDebuggerComponent values={values} showDebugger={false}/>
                                <div className="t-form-controls">
                                    <div className="relationship--permission-heading">Assign Relationship</div>
                                    <p className={'mrg-bottom-10'}>Choose how you are connected to the above mentioned
                                        profile</p>
                                    <Field name={'relationship'}>
                                        {
                                            (field: FieldProps) => (
                                                <FormikSelectDropdownComponent
                                                    options={relationshipList}
                                                    placeholder={'Select Relationship'}
                                                    formikField={field}
                                                    // disabled={(currentUser?._id !== selectedProfile?.requested_by)}
                                                    fullWidth={true}
                                                    isClearable={false}
                                                />
                                            )
                                        }
                                    </Field>
                                    <div className="pdd-top-20">
                                        <AccordionComponent
                                            title={<Field name={'permission_type'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikRadioButtonComponent
                                                            displayWith={(option: any) => `${CommonService.capitalizeFirstLetter(option?.title)}`}
                                                            valueExtractor={(option: any) => option.code}
                                                            keyExtractor={(option: any) => option.code}
                                                            option={mutual_access_object}
                                                            formikField={field}
                                                            required={true}
                                                        />
                                                    )
                                                }
                                            </Field>}
                                        >
                                            <div className="mutual-access-content-wrapper-2">
                                                <p className={'pdd-bottom-20'}>This permission:</p>
                                                <ul className={'pdd-left-15 pdd-bottom-15'}>
                                                    <li className={'pdd-bottom-15'}>Gives the other person
                                                        access to your
                                                        account to book appointments and manage
                                                        your
                                                        account on your behalf.
                                                    </li>
                                                    <li className={' pdd-bottom-15'}>Gives you access to
                                                        their account to
                                                        book appointments and manage their
                                                        account.
                                                    </li>
                                                    <li className={'pdd-bottom-15'}>Can be rescinded at any
                                                        time.
                                                    </li>
                                                </ul>
                                            </div>
                                        </AccordionComponent>
                                    </div>
                                    <div className="pdd-top-20">
                                        <AccordionComponent
                                            title={<Field name={'permission_type'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikRadioButtonComponent
                                                            displayWith={(option: any) => `${CommonService.capitalizeFirstLetter(option?.title)}`}
                                                            valueExtractor={(option: any) => option.code}
                                                            keyExtractor={(option: any) => option.code}
                                                            option={no_mutual_access_object}
                                                            formikField={field}
                                                            required={true}
                                                        />
                                                    )
                                                }
                                            </Field>}
                                        >
                                            <div className="mutual-access-content-wrapper">
                                                <p className={'pdd-bottom-20'}>This permission:</p>
                                                <ul className={'pdd-left-15 pdd-bottom-15'}>
                                                    <li className={'pdd-bottom-15'}>Denies the other person
                                                        permission to access your account.
                                                    </li>
                                                    <li className={'pdd-bottom-15'}>Can be changed at any
                                                        time.
                                                    </li>
                                                </ul>
                                            </div>
                                        </AccordionComponent>
                                    </div>
                                </div>
                                <div className="t-form-actions">
                                    <ButtonComponent
                                        color={'accent'}
                                        variant={'outlined'}
                                        className={'mrg-right-15'}
                                        onClick={() => {
                                            setViewDetailsStep('view');
                                        }}
                                    >
                                        Cancel
                                    </ButtonComponent>
                                    <ButtonComponent
                                        color={'accent'}
                                        type={'submit'}
                                        disabled={accountDetailFormInitialValues === values || !isValid}
                                        className={'mrg-left-10'}
                                        variant={'contained'}>
                                        Resend Request
                                    </ButtonComponent>
                                </div>
                            </Form>
                        )
                    }}
                </Formik>
            </>
            }
        </div>

    )
}

export default ViewAccountDetailsComponent;




